import { LOGOS } from '@/config/logos'
import React from 'react'
import { Link } from 'react-router-dom'

const FooterInstitut = () => {
  return (
    <footer className="bg-[#1d70b7] text-white py-10 md:py-12 lg:py-16 px-4 sm:px-6 md:px-10 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 lg:gap-12 mb-8 md:mb-12">
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              <Link to="/institut" className="flex items-center space-x-3 group">
                <img
                  src={LOGOS.institut}
                  alt="Institut"
                  className="h-16 w-auto transition-transform duration-300 group-hover:scale-105"
                />
              </Link>
            </h3>
            <p className="text-sm md:text-base text-green-100 leading-relaxed">
              Institut d'enseignement supérieur d'excellence formant les leaders de demain.
            </p>
          </div>
          <div>
            <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4">Formations</h4>
            <ul className="space-y-2 text-sm md:text-base text-green-100">
              <li><Link to="/institut/instance" className="hover:text-white transition-colors">Instance</Link></li>
              <li><Link to="/institut/frais" className="hover:text-white transition-colors">Frais Inscription</Link></li>
              <li><Link to="/institut/pronote" className="hover:text-white transition-colors">Pronote</Link></li>
              <li><Link to="/institut/transport" className="hover:text-white transition-colors">Transport</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4">Liens Rapides</h4>
            <ul className="space-y-2 text-sm md:text-base text-green-100">
              <li><Link to="/institut/actualites" className="hover:text-white transition-colors">Actualités</Link></li>
              <li><Link to="/institut/projets" className="hover:text-white transition-colors">Futurs Projets</Link></li>
              <li><Link to="/institut/galerie" className="hover:text-white transition-colors">Galerie</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4">Contact</h4>
            <ul className="space-y-2 md:space-y-3 text-sm md:text-base text-green-100">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Riviera Attoban, cité les vallées, Rue L167, Abidjan, Côte d'Ivoire</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span> +225 0787670940
                  {/* <br /> +225 0709650928 */}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span className="break-all">accueil.univ.fredetpoppee@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-green-700 pt-6 md:pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs sm:text-sm md:text-base text-green-100 text-center sm:text-left">© 2025 Groupe Fred & Poppée. Tous droits réservés.</p>
          <a href="#" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm md:text-base text-green-100 hover:text-white transition-colors whitespace-nowrap">
            Designé par Fred & Poppée
          </a>
        </div>
      </div>
    </footer>
  )
}

export default FooterInstitut